module.exports = __webpack_public_path__ + "static/media/googlegbm-new.b63e4f6d.svg";